(function () {
  'use strict';

  var dialog = document.querySelector('[data-bb-confirm-dialog]');
  if (!dialog || typeof dialog.showModal !== 'function') return;

  var title = dialog.querySelector('[data-bb-confirm-title]');
  var description = dialog.querySelector('[data-bb-confirm-description]');
  var cancelButton = dialog.querySelector('[data-bb-confirm-cancel]');
  var confirmButton = dialog.querySelector('[data-bb-confirm-accept]');
  var pendingResolve = null;
  var returnFocus = null;

  function finish(confirmed) {
    if (!pendingResolve) return;

    var resolve = pendingResolve;
    var focusTarget = returnFocus;
    pendingResolve = null;
    returnFocus = null;

    if (dialog.open) dialog.close();
    resolve(confirmed);
    if (focusTarget && typeof focusTarget.focus === 'function') focusTarget.focus();
  }

  function ask(options) {
    options = options || {};
    if (pendingResolve) finish(false);

    title.textContent = options.title || 'Are you sure?';
    description.textContent = options.message || '';
    cancelButton.textContent = options.cancelLabel || 'Cancel';
    confirmButton.textContent = options.confirmLabel || 'Continue';
    returnFocus = options.trigger || document.activeElement;

    return new Promise(function (resolve) {
      pendingResolve = resolve;
      dialog.showModal();
      cancelButton.focus();
    });
  }

  cancelButton.addEventListener('click', function () { finish(false); });
  confirmButton.addEventListener('click', function () { finish(true); });
  dialog.addEventListener('cancel', function (event) {
    event.preventDefault();
    finish(false);
  });
  dialog.addEventListener('click', function (event) {
    if (event.target === dialog) finish(false);
  });
  dialog.addEventListener('close', function () { finish(false); });

  window.BBConfirm = Object.freeze({ask: ask});
})();
